import React, { useState, useEffect, useMemo } from "react"
import Button from "@mui/material/Button"
import Checkbox from "@mui/material/Checkbox"
import FormControlLabel from "@mui/material/FormControlLabel"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { StyledProgramCategoryDialog } from "./ProgramCategoryDlg.style"

const ProgramCategoryDialog = (props) => {
  const { categories, programSubCategories, onUpdate } = props
  const [selectedSubCategory, setSelectedSubCategory] =
    useState(programSubCategories || [])
  const [open, setOpen] = useState(false)
  const [loading] = useState(false)

  const openDlg = async (_programId) => {
    setSelectedSubCategory(programSubCategories || [])
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    setSelectedSubCategory(programSubCategories || [])
  }, [programSubCategories])

  const selectedSubCategoryIds = useMemo(() => {
    return new Set((selectedSubCategory || []).map((el) => el.subCategoryId))
  }, [selectedSubCategory])

  const onCheckBoxChange = (e, category, subCategory) => {
    if (e.target.checked) {
      setSelectedSubCategory((prev) => {
        const currentSelection = prev || []
        if (currentSelection.some((el) => el.subCategoryId === subCategory.id)) {
          return currentSelection
        }
        return [
          ...currentSelection,
          {
            categoryId: category.id,
            categoryName: category.name,
            subCategoryId: subCategory.id,
            subCategoryName: subCategory.name,
          },
        ]
      })
    } else {
      setSelectedSubCategory((prev) =>
        (prev || []).filter((el) => el.subCategoryId !== subCategory.id)
      )
    }
  }

  const dlg = (
    <StyledProgramCategoryDialog open={open} onClose={handleClose}>
      <DialogTitle>
        <h3 className="dialog-title">Category Selector</h3>
        <p className="dialog-subtitle">
          {`Selected subcategories: ${
            selectedSubCategory?.length || 0
          }`}
        </p>
      </DialogTitle>
      <DialogContent>
        <div className="category-grid">
          {(categories || []).map((category) => (
            <div
              key={`category-list-item-${category.id}`}
              className="category-section"
            >
              <div className="category-heading">
                <h5 className="category-name">{category.name}</h5>
                <span className="subcategory-count">
                  {`${(category.subCategoryList || []).length} sub`}
                </span>
              </div>
              <div className="subcategory-section">
                {(category.subCategoryList || []).length === 0 && (
                  <p className="subcategory-empty">
                    No subcategories available.
                  </p>
                )}
                {(category.subCategoryList || []).map((subCategory) => (
                  <FormControlLabel
                    key={`subCategory-list-item-label-${subCategory.id}`}
                    control={
                      <Checkbox
                        checked={selectedSubCategoryIds.has(subCategory.id)}
                        onChange={(e) => {
                          onCheckBoxChange(e, category, subCategory)
                        }}
                      />
                    }
                    label={subCategory.name}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
      <DialogActions>
        <Button className="dialog-close-btn" onClick={handleClose}>
          Close
        </Button>
        <Button
          variant="contained"
          className="dialog-submit-btn"
          onClick={() => {
            onUpdate(selectedSubCategory)
            setOpen(false)
          }}
        >
          Update
        </Button>
      </DialogActions>
    </StyledProgramCategoryDialog>
  )

  return [openDlg, dlg, loading]
}

export default ProgramCategoryDialog
